import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

const MEDALS = ["🥇", "🥈", "🥉"];

export default function WeeklyTopPredictors() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/predictions/weekly-top").then((r) => {
      setRows(r.data?.rows || []);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  if (!loaded) return null;

  return (
    <div className="border border-[#232330]" data-testid="weekly-top-predictors">
      <div className="px-5 py-4 border-b border-[#232330] bg-[#0a0a12] flex items-center gap-2">
        <Flame className="w-4 h-4 text-[#FF007F]" />
        <span className="font-heading font-black uppercase tracking-tight">This week's top</span>
        <span className="ml-auto text-[10px] font-mono tracking-widest text-gray-500 uppercase">Last 7 days</span>
      </div>
      {rows.length === 0 ? (
        <div className="px-5 py-6 text-sm text-gray-500">No predictions scored this week yet — be the first.</div>
      ) : (
        <ul className="divide-y divide-[#232330]">
          {rows.slice(0, 5).map((r) => (
            <li key={r.user_id} data-testid={`weekly-top-${r.rank}`} className="flex items-center gap-3 px-5 py-3">
              <span className="font-mono text-base w-8">
                {r.rank <= 3 ? MEDALS[r.rank - 1] : <span className="text-gray-500 text-xs">#{r.rank}</span>}
              </span>
              <div className="flex-1 min-w-0">
                <div className="font-heading font-bold uppercase tracking-tight text-sm truncate">{r.name}</div>
                <div className="font-mono text-[10px] text-gray-500 mt-0.5">
                  {r.exact} exact · {r.correct}/{r.picks} called
                </div>
              </div>
              <div className="font-mono font-bold text-cyan-400 text-base">{r.points}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
